import values from 'lodash/values'

import PostModel from 'apps/posting/models/Post'
import { ListName } from 'apps/posting/models/Post/constants'
import * as postSelectors from 'apps/posting/selectors/postSelectors'
import { BroadcastingApi } from 'shared/api/requests/broadcasting'
import { createAsyncAction } from 'shared/lib/redux'

export const loadPostList = createAsyncAction(
  'postListActions/loadPostList',
  async (listName: ListName, { getState }) => {
    const state = getState()

    if (!values(ListName).includes(listName)) {
      throw new Error(`loadPostList: unknown listName "${listName}"`)
    }

    const { limiter } = postSelectors.getListMeta(state, listName)

    let response
    if (listName === ListName.DRAFTS) {
      response = await BroadcastingApi.loadDrafts({ query: { limiter } })
    }
    if (listName === ListName.SCHEDULED) {
      response = await BroadcastingApi.loadScheduled({ query: { limiter } })
    }
    if (listName === ListName.HISTORY) {
      response = await BroadcastingApi.loadHistory({ query: { limiter } })
    }

    if (response) {
      const items = response.data.posts.map(PostModel.adapter)

      return {
        limiter: response.data.limiter,
        total: response.data.total,
        items,
        listName,
      }
    }

    return
  },
)

export const ensurePostList = createAsyncAction(
  'postListActions/ensurePostList',
  async (listName: ListName, { dispatch, getState }) => {
    const state = getState()
    const { fetched, loading } = postSelectors.getListMeta(state, listName)

    if (fetched || loading) {
      return
    }

    return dispatch(loadPostList(listName))
  },
)
